import { generateBlobUrlWithHtml } from "../generateBlobUrlWithHtml";

export interface ParseResult {
  html_content: string;
  agent_message: string;
}

export function extractHtmlCode(input: string): ParseResult {
  const codeBlockRegex = /```(?:\w+)?\s*([\s\S]*?)```|`([^`]*)`/g;
  const matches: { match: string; content: string; index: number }[] = [];
  let match;

  while ((match = codeBlockRegex.exec(input)) !== null) {
    const content = match[1] !== undefined ? match[1] : match[2];

    if (isValidHtmlStructure(content)) {
      matches.push({
        match: match[0],
        content: content.trim(),
        index: match.index,
      });
    }
  }

  if (matches.length === 0 && isValidHtmlStructure(input)) {
    const safeFilename = "index.html";
    const safeUrl = generateBlobUrlWithHtml(input.trim());

    return {
      html_content: input.trim(),
      agent_message: input.replace(
        /.+/,
        `<file data-url="${safeUrl}" data-filename="${safeFilename}">Ваш код приложения</file>`,
      ),
    };
  }

  if (matches.length === 0) {
    return { html_content: "", agent_message: input };
  }

  const lastBlock = matches[matches.length - 1];
  let newMessage = input;

  matches.sort((a, b) => a.index - b.index);

  for (let i = matches.length - 1; i >= 0; i--) {
    const block = matches[i];
    if (i === matches.length - 1) {
      const safeFilename = "index.html";
      const safeUrl = generateBlobUrlWithHtml(lastBlock.content.trim());
      newMessage =
        newMessage.substring(0, block.index) +
        `<file data-url="${safeUrl}" data-filename="${safeFilename}">Ваш код приложения</file>` +
        newMessage.substring(block.index + block.match.length);
    } else {
      newMessage =
        newMessage.substring(0, block.index) +
        "" +
        newMessage.substring(block.index + block.match.length);
    }
  }

  return {
    html_content: lastBlock.content,
    agent_message: newMessage,
  };
}

export function isValidHtmlStructure(text: string): boolean {
  if (!text || text.length < 5) return false;

  const parser = new DOMParser();
  const doc = parser.parseFromString(text, "text/html");

  const hasStructure =
    doc.body.children.length > 0 || doc.documentElement.tagName === "HTML";

  const hasTags = /<\/?[a-z][\s\S]*>/i.test(text);

  return hasStructure && hasTags;
}
